import { getCurrentHub } from '@sentry/core';

var _originalRecordDroppedEvent;

function overwriteRecordDroppedEvent(errorIds) {
  var client = getCurrentHub().getClient();

  if (!client) {
    return;
  }

  var _originalCallback = client.recordDroppedEvent.bind(client);

  var recordDroppedEvent = function recordDroppedEvent(reason, category, event) {
    if (event && !event.type && event.event_id) {
      errorIds.delete(event.event_id);
    }

    return _originalCallback(reason, category, event);
  };

  client.recordDroppedEvent = recordDroppedEvent;
  _originalRecordDroppedEvent = _originalCallback;
}

function restoreRecordDroppedEvent() {
  var client = getCurrentHub().getClient();

  if (!client || !_originalRecordDroppedEvent) {
    return;
  }

  client.recordDroppedEvent = _originalRecordDroppedEvent;
}

export { overwriteRecordDroppedEvent, restoreRecordDroppedEvent };